import React, { useContext, useState } from "react";

import "./stylesLocationRestrictions.css";
import LocationRestrictionsTableRow from "./LocationRestrictionsTableRow/LocationRestrictionsTableRow";
import RebetLoader from "../CommonComponents/RebetLoader/RebetLoader";
import Layout from "../CommonComponents/Layout/Layout";

import FilterIcon from "../../assets/icons/ic_filter.svg";
// import SearchIcon from "../../assets/icons/ic_search.png";
import { ChevronUp, Filter, Search } from "react-feather";
import AppContext from "../../context/AppContext";
import { SIDER_TABS } from "../../utils/Constants";
import LocationRestrictionsPopup from "./LocationRestrictionsPopup/LocationRestrictionsPopup";

function LocationRestrictions() {
  const { setActiveSidebarTab } = useContext(AppContext);

  const [isApiRunning, setIsApiRunning] = useState(false);
  const [
    isLocationRestrictionsPopupVisible,
    setLocationRestrictionsPopupVisible,
  ] = useState(false);

  const [data, setData] = useState([
    {
      id: 0,
      state: "Alabama",
      note: "Update description",
      ability: 2,
      restrictions: 2500,
      activity: true,
    },
    {
      id: 1,
      state: "Arkansas",
      note: "Update description",
      ability: 1,
      restrictions: "",
      activity: true,
    },
    {
      id: 2,
      state: "Arizona",
      note: "Update description",
      ability: 0,
      restrictions: "",
      activity: false,
    },
  ]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });

    setData(sortedData);
  };

  useState(() => {
    setActiveSidebarTab(SIDER_TABS.CONFIGURATIONS, "Location Restrictions");
  }, [setActiveSidebarTab]);

  return (
    <Layout>
      <div className="location-restrictions-table-container">
        <div className="location-restrictions-table">
          <LocationRestrictionsPopup
            isVisible={isLocationRestrictionsPopupVisible}
            onClosePressed={setLocationRestrictionsPopupVisible}
            getEventCodesList={() => {}}
          />
          <button onClick={() => setLocationRestrictionsPopupVisible(true)}>
            click here
          </button>
          <>
            <div className="head-controls">
              <div className="header-text-container">
                <p className="header-text">Location Restrictions</p>
              </div>
            </div>

            <div className="location-search-container">
              <Search className="search-icon" />
              <input
                type="text"
                placeholder="Search"
                className="location-search"
              />
              <div className="divider"></div>
              <div className="filter-buttons">
                <Filter className="filter-icon" />
                <ChevronUp className="filter-icon" />
              </div>
            </div>

            <div className="table-container">
              {isApiRunning ? (
                <RebetLoader height={"100px"} width={"100px"} />
              ) : (
                <>
                  <LocationRestrictionsTableRow
                    is_header_row={true}
                    data={{}}
                    handleSort={handleSort}
                  />

                  {data &&
                    data.map((data, index) => (
                      <LocationRestrictionsTableRow
                        key={index}
                        is_header_row={false}
                        data={data}
                        handleSort={() => {}}
                      />
                    ))}
                </>
              )}
            </div>
          </>
        </div>
      </div>
    </Layout>
  );
}

export default LocationRestrictions;
